module.exports = __webpack_public_path__ + "static/media/tutorial_money_one@2x.21d4d671.png";